import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  query($order: [SchoolsFindOrder!],$where: SchoolsFindFilter) {\n    exportSchoolsList(\n      order: $order,\n      where: $where\n    ) {\n      fileName\n      contentB64\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  mutation($schoolId: Int!) {\n    deleteSchool(\n      schoolId: $schoolId,\n    ) \n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  query($order: [AreasFindOrder!], $paging: PagingQuery, $where: AreasFindFilter) {\n    findAreas(\n      order: $order,\n      paging: $paging,\n      where: $where,\n    ) {\n      areas {\n        cityCode\n        createdAt\n        id\n        ing\n        lat\n        levelType\n        managers {\n          createdBy {\n            id\n            username\n          }\n          modifiedBy {\n            id\n            username\n          }\n        }\n        mergerName\n        name\n        parentId\n        pinyin\n        shortName\n        updatedAt\n        zipCode\n      }\n      paging {\n        currentOffset\n        take\n        totalCount\n      }\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  query($parentId: Int) {\n    queryAreas(\n      parentId: $parentId,\n    ) {\n      cityCode\n      createdAt\n      id\n      ing\n      lat\n      levelType\n      managers {\n        createdBy {\n          id\n          username\n        }\n        modifiedBy {\n          id\n          username\n        }\n      }\n      mergerName\n      name\n      parentId\n      pinyin\n      shortName\n      updatedAt\n      zipCode\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query($order: [SchoolsFindOrder!], $paging: PagingQuery, $where: SchoolsFindFilter) {\n    findSchools(\n      order: $order,\n      paging: $paging,\n      where: $where,\n    ) {\n      schools {\n        area {\n          cityCode\n          createdAt\n          id\n          ing\n          lat\n          levelType\n          managers {\n            createdBy {\n              id\n              username\n            }\n            modifiedBy {\n              id\n              username\n            }\n          }\n          mergerName\n          name\n          parentId\n          pinyin\n          shortName\n          updatedAt\n          zipCode\n        }\n        dealers {\n          id\n          realname\n          storeName\n          storePhone\n          status\n          user {\n            phone\n          }\n        }\n        areaId\n        createdAt\n        id\n        managers {\n          createdBy {\n            id\n            username\n          }\n          modifiedBy {\n            id\n            username\n          }\n        }\n        name\n        status\n        updatedAt\n      }\n      paging {\n        currentOffset\n        take\n        totalCount\n      }   \n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query($schoolId: Int!) {\n    findSchool(\n      schoolId: $schoolId,\n    ) {\n      area {\n        cityCode\n        createdAt\n        id\n        ing\n        lat\n        levelType\n        managers {\n          createdBy {\n            id\n            username\n          }\n          modifiedBy {\n            id\n            username\n          }\n        }\n        mergerName\n        name\n        parentId\n        pinyin\n        shortName\n        updatedAt\n        zipCode\n      }\n      dealers {\n        id\n        realname\n        storeName\n        storePhone\n        status\n        user {\n          phone\n        }\n      }\n      areaId\n      createdAt\n      id\n      managers {\n        createdBy {\n          id\n          username\n        }\n        modifiedBy {\n          id\n          username\n        }\n      }\n      name\n      status\n      updatedAt\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var findSchool = gql(_templateObject());
export var findSchools = gql(_templateObject2());
export var queryAreas = gql(_templateObject3());
export var findAreas = gql(_templateObject4());
export var deleteSchool = gql(_templateObject5());
export var exportSchoolsList = gql(_templateObject6());